module.exports = __webpack_public_path__ + "sunsemweb/img/video2.8a45101a.png";